import { Checkbox, FormControlLabel } from '@mui/material'
import React from 'react'
import { genericHandleChange } from 'src/consumer/helpers/utilFunctions'

export default function RosterFilterWidget({ filters, setFilters }) {
  function handleChange(e) {
    genericHandleChange(e, setFilters)
  }

  return (
    <div className="d-flex flex-column gap-2 w-100">
      <h6>Filters</h6>
      <div className="d-flex flex-column gap-1">
        <div className="d-flex align-items-center gap-2">
          <FormControlLabel
            control={
              <Checkbox id="rosterItems" checked={filters?.rosterItems} onChange={handleChange} />
            }
            size="small"
            label="Roster Items"
          />
        </div>
        <div className="d-flex align-items-center gap-2">
          <FormControlLabel
            control={
              <Checkbox id="unpaidEvents" checked={filters?.unpaidEvents} onChange={handleChange} color="error" />
            }
            size="small"
            label="Payment Pending"
          />
        </div>
        <div className="d-flex align-items-center gap-2">
          <FormControlLabel
            control={
              <Checkbox
                color="success"
                id="completedEvents"
                checked={filters?.completedEvents}
                onChange={handleChange}
              />
            }
            size="small"
            label="Completed"
          />
        </div>
      </div>
      <div className="d-flex align-items-center gap-2">
        <FormControlLabel
          control={
            <Checkbox
              color="unFocused"
              id="notStarted"
              checked={filters?.notStarted}
              onChange={handleChange}
            />
          }
          size="small"
          label="Not Started"
        />
      </div>
    </div>
  )
}
